import { Loader } from 'lucide-react'
import React from 'react'
import './style.scss'
export function CustomLoader() {
  return (
    <div >
        <Loader size={50}  className="loader-spin"/>

      </div> 
  )
}

